export default __webpack_public_path__ + "assets/images/features_neutrality-784e045ce109cb35dc4ebedad046a35b.png";